import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=cf6ac016&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf6ac016')) {
      api.createRecord('cf6ac016', component.options)
    } else {
      api.reload('cf6ac016', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=cf6ac016&", function () {
      api.rerender('cf6ac016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-47nv6WJ24rFeb/JS/comp/FavElement.vue"
export default component.exports